<template>
  <el-row class="mb-3" v-if="amReady">
    <div class="m-0 p-0 mb-4" v-if="formHeader">
      <h6>{{ this.getFormTitle }}</h6>
    </div>
    <div class="mb-2" v-else></div>

    <el-col :class="$langConfig.cssClass" :span="(!editMode)? 5 : 5">
      <dg-select-field
          :control="control"
          :field_span="22"
            :label_span="22"
          :options="vendorsList"
          :translateLabel="false"
          :translateLabels="false"
          @amUpdated="vendorChanged"
          field_mark="required"
          label="Vendor"
          name="vendor_id"
          rules="required"></dg-select-field>
    </el-col>

    <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
      <dg-select-field
          :control="control"
          :disabled="true"
          :field_span="16"
          :label_span="24"
          :options="divisionsList"
          :translateLabel="false"
          :translateLabels="false"
          field_mark="required"
          label="Division"
          name="division_id"
          rules="required"></dg-select-field>
    </el-col>

    <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
      <dg-select-field
          :control="control"
          :field_span="22"
            :label_span="22"
          :options="destinationsDropDownList"
          :translateLabel="false"
          :translateLabels="false"
          field_mark="required"
          htmlautocomplete="new-password"
          label="Destination"
          labelProperty="label"
          name="destination_id"
          placeholder="Canada / ATI"
          rules="required"
          valueProperty="value"
      ></dg-select-field>
    </el-col>

    <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4">
      <dg-text-field
          :control="control"
          :field_span="22"
            :label_span="22"
          :translateLabel="false"
          field_mark="required"
          label="Rate"
          name="rate"
          placeholder="0.0002"
          rules="required"></dg-text-field>
    </el-col>

    <el-col :class="$langConfig.cssClass" :span="(!editMode)? 5 : 5">
      <dg-switch
          :control="control"
          :defaultValue="false"
          :field_span="22"
            :label_span="22"
          :translateLabel="false"
          @amUpdated="rateUpdated"
          field_mark=""
          label="Active"
          name="is_active"
          rules=""></dg-switch>
    </el-col>

    <el-col :span="24" class="mt-2 border-top">
      <el-col :class="$langConfig.cssClass" :span="12" class="mt-4">
        <label class="error-field-validate-message text-capitalize"
               v-show="!this.validData">{{ (requestErrorMessage) ? requestErrorMessage : 'fields_do_not_match_the_required_criteria' }}</label>
      </el-col>
      <el-col :span="12" class="pt-3 text-right">
        <dg-confirm-button
            :loading="requestOn"
            :onConfirm="removeAction"
            :translate="false"
            class="mr-2"
            confirmButtonType="danger"
            fieldSize="mini"
            icon="el-icon-delete"
            popIcon="el-icon-delete"
            text="remove"
            title="sure to removing this record ?"
            type="danger"
            v-if="editMode"></dg-confirm-button>

        <dg-button :click="cancelEditable" class="mr-2" fieldSize="mini" icon="el-icon-close" text="cancel"
                   type="warning" v-if="editable && editMode"></dg-button>
        <dg-button :click="changeEditable" fieldSize="mini" icon="el-icon-edit" text="edit" type="success"
                   v-if="!editable && editMode"></dg-button>
        <dg-confirm-button
            :icon="actionButtonIcon"
            :loading="requestOn"
            :onConfirm="createModule"
            :text="actionButtonLabel"
            :translate="false"
            :type="actionButtonType"
            fieldSize="mini"
            v-if="editable"></dg-confirm-button>
      </el-col>
    </el-col>
  </el-row>
</template>

<script>


import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import module from './../index.js'
import {notify} from '@/system-services/notify.js'

export default {
  mixins: [fieldController],
  props: {
    customerUserId: {
      required: false
    },
    userUsingPrivateRate: {
      required: true
    },
    formHeader: {
      required: false,
      default: false
    },
    formTitle: {
      required: false
    },
    editMode: {
      required: true,
      type: Boolean
    },
    onEditCallback: {
      required: false
    },
    onCreateCallback: {
      required: false
    },
    moduleDeleteAction: {
      required: false
    }
  },
  data() {
    return {
      requestErrorMessage: null,
      dataModel: {rate: false},
      destinationsDropDownList: [],
      divisionsList: [],
      control: this,
      amReady: false,
      requestOn: false,
      editable: !this.editMode,
      vendorsList: [],
      module: {
        ...module
      }
    }
  },
  computed: {
    ...$mapState('voip-dialplan-state', ['openedEntity']),
    ...$mapState('ajaxManager', ['loadingRequests']),
    getFormTitle: function () {
      if (this.formTitle) {
        return this.formTitle
      } else {
        return ((!this.editMode) ? this.$ml.get('create') : this.$ml.get('edit')) + ' ' + this.module.info.caption
      }
    },
    actionButtonLabel: function () {
      if (!this.editMode) {
        return 'create';
      } else {
        return 'save'
      }
    },
    actionButtonIcon: function () {
      if (!this.editMode) {
        return 'el-icon-plus';
      } else {
        return 'el-icon-check'
      }
    },
    actionButtonType: function () {
      if (!this.validData) {
        return 'danger btn-small';
      } else {
        if (!this.editMode) {
          return 'primary app-bg-primary';
        } else {
          return 'primary'
        }
      }
    }
  },
  beforeMount() {
    this.getWorkingDestinationsDropdownlist().then((r) => {
      this.destinationsDropDownList = r
    })

    this.getDivisionsDropDownList().then(r => {
      this.divisionsList = r
    })


    this.getVendorDropDownList().then(r => {
      this.vendorsList = r
      this.amReady = true
      if (this.editMode) {
        $vue.nextTick(() => {
          this.dataToBind.vendor_id = 612
          this.setDisplayData(this.dataToBind)
        })
      }
    })
  },
  methods: {
    rateUpdated(inputField) {
      let val = inputField.field.field_value
    },
    vendorChanged(params) {
      let vendorId = params.field.field_value
      this.getVendorDivision({id: vendorId}).then((r) => {
        this.fields['division_id'].field.field_value = r.data
        this.fields['division_id'].field.validateMessage = ''
        this.fields['division_id'].field.updateValue()
      })
    },
    ...$mapActions('voip-vendor-api', {
      getVendorDropDownList: 'getDropDownList',
      getVendorDivision: 'getVendorDivision',
    }),
    ...$mapActions('voip-dialplan-state', ['addEntity']),
    ...$mapActions('voip-rate-division-api', {getDivisionsDropDownList: 'getDropDownList'}),
    ...$mapActions('voip-vendor-destination-status-api', {
      getWorkingDestinationsDropdownlist: 'workingDropDownList',
    }),
    cancelEditable() {
      let context = this
      this.amReady = false
      this.editable = false
      $vue.nextTick(() => {
        context.amReady = true
      })
    },
    changeEditable() {
      this.editable = !this.editable
    },
    getEntityField() {
      return JSON.parse(this.openedEntity.fields);
    },
    removeAction() {
      this.moduleDeleteAction()
    },
    createModule() {
      this.validateFields().then(result => {
        if (!result) return

        this.requestOn = true
        let context = this;
        let data = {data: this.dataModel};
        if (this.editMode) {
          data.id = this.dataToBind.id;
        } else {
          if (this.userUsingPrivateRate) {
            data.data.customer_user_id = this.customerUserId
          }
        }

        let api = (this.editMode) ? 'update' : 'create';
        this.$store.dispatch(this.module.info.name + '-api/' + api, data).then(response => {
          this.amReady = false
          notify({
            type: 'success',
            title: this.$ml.get('successfully'),
            message: '',
            position: 'topRight',
            close: false,
            timeout: 1900,
            animateInside: true,
          });

          $vue.nextTick(() => {
            context.amReady = true
            context.requestOn = false
            if (context.editMode) {
              if (context.onEditCallback) {
                context.onEditCallback(response.data)
              }
            } else {
              if (context.onCreateCallback) {
                context.onCreateCallback(response.data)
              }
            }
          })
          // this.$router.push({ name: this.module.stateName + '-module-list', params: {}}).then( response => {})
        }).catch(error => {
          console.log('catch error', error)
          if (error.response.data.errorMessage) {
            this.validData = false
            this.requestErrorMessage = error.response.data.errorMessage
          } else {
            this.setfieldsErrorMessage({
              fieldsErrors: error.response.data
            });
          }
        }).finally(() => {
          this.requestOn = false
        })

      })
    }
  }
}
</script>
